<div class="selections-container">
  <label class="info-header">{{title}}</label>
  <table class="is-hidden-mobile">
    <tr>
      <td class="info-label">{{primaryUseLabel}}</td>
      <td class="info-text">{{primaryUse}}</td>
    </tr>
    <tr>
      <td class="info-label">{{needToRunLabel}}</td>
      <td class="info-text">{{needToRun}}</td>
    </tr>
    <tr>
      <td class="info-label">{{useCaseLabel}}</td>
      <td class="info-text">{{useCase}}</td>
    </tr>
    <tr>
      <td class="info-label">{{brandsLabel}}</td>
      <td class="info-text">{{brands}}</td>
    </tr>
  </table>
  <div class="is-hidden-tablet selections-mobile">
    <div>
      <div class="info-label">
        {{primaryUseLabel}}
      </div>
      <div class="info-text">
        {{primaryUse}}
      </div>
      <div class="buffer-small"></div>
    </div>
    <div>
      <div class="info-label">
        {{needToRunLabel}}
      </div>
      <div class="info-text">
        {{needToRun}}
      </div>
      <div class="buffer-small"></div>
    </div>
    <div>
      <div class="info-label">
        {{brandsLabel}}
      </div>
      <div class="info-text">
        {{brands}}
      </div>
    </div>
  </div>
</div>
